import { createContext, useContext } from 'react';

interface ReleaseNotesControls {
  openHistory: () => void;
}

const ReleaseNotesContext = createContext<ReleaseNotesControls | null>(null);

export const ReleaseNotesContextProvider = ReleaseNotesContext.Provider;

export function useReleaseNotesControls(): ReleaseNotesControls | null {
  return useContext(ReleaseNotesContext);
}
